// Components==============
import { motion } from 'framer-motion';
import React from 'react';
// =========================

const Boats = React.memo(() => (
    <>
        <motion.g
            id="GreenBoat"
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [0, 1, -2, 1, -3, 1, 0, 2, -1, 0, 0],
                y: [0, 4, -3, 4, -3, 4, -3, 2, -3, 4, -3, 4, 0],
            }}
            transition={{
                duration: 15,
                repeat: Infinity,
                bounce: 0.25,
            }}
        >
            <path
                d="m1185.63,1785.15c6.15-2.64,6.19-9.24.06-11.92"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth=".33"
            />
            <path
                d="m1187.95,1785.66c2.69-1.15,4.21-3.07,4.56-5.08"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth=".33"
            />
            <path
                d="m1169.42,1765.74l-25.88,14.9c-5.06,2.91-5.08,10.19-.05,13.14l4.14,2.43c4.76,2.79,10.65,2.81,15.43.06l22.63-13.03c5.5-3.17,5.53-11.09.06-14.3l-5.4-3.16c-3.37-1.98-7.54-1.99-10.93-.04Z"
                fill="#98f4c1"
                strokeWidth="0"
            />
            <path
                d="m1170.64,1783.26h-5.46c2.8,2.69,3.41,6.35,0,11.79l5.46-3.14c2.64-4.53,2.45-7.3,0-8.65Z"
                fill="#28e57d"
                strokeWidth="0"
            />
            <path
                d="m1182.27,1776.58h-5.46c1.95,2.47,3.21,5.46,0,11.79l5.46-3.14c2.19-5.23,2.16-8.08,0-8.65Z"
                fill="#28e57d"
                strokeWidth="0"
            />
            <path
                d="m1141.61,1795.72l4.64,2.72c5.32,3.12,11.92,3.15,17.26.07l6.55-3.77"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth=".38"
            />
            <path
                d="m1143.24,1799.74c7.15,4.2,16.01,4.23,23.2.09"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth=".38"
            />
            <path
                d="m1169.79,1767.65l-19.27,11.09c-2.34,1.35-2.35,4.72-.02,6.09l6.24,3.66c2.46,1.44,5.5,1.45,7.98.03l19.27-11.09c2.34-1.35,2.35-4.72.02-6.09l-6.24-3.66c-2.46-1.44-5.5-1.45-7.98-.03Z"
                fill="#16d872"
                strokeWidth="0"
            />
            <path
                d="m1179.6,1772.75s9.08-6.6,14.84-1.06l-2.64,4.02c-2.98-4.3-7.33-3.16-11.9-1.76"
                fill="#5f3817"
                strokeWidth="0"
            />
            <polygon
                points="1167.97 1776.47 1156.79 1786.01 1158.87 1787.22 1171.51 1779.91 1167.97 1776.47"
                fill="#5f3817"
                strokeWidth="0"
            />
            <path
                d="m1150.94,1759.76s1.76-3.8,1.8-5c.04-1.2,2.36,2.76.8,5"
                fill="#825c3c"
                strokeWidth="0"
            />
            <ellipse
                cx="1149.43"
                cy="1760.62"
                rx=".66"
                ry="1.1"
                fill="#fff"
                strokeWidth="0"
            />
            <path
                d="m1165.32,1777.5l6.11,6.19,6.37-3.89c3.72-2.27,3.62-7.71-.18-9.85l-19.99-11.25c-2.17-1.22-4.86-1.05-6.85.44l-.31.24c-2.32,1.73-3.82,4.34-4.15,7.22l-.1.85c-.07.6.24,1.18.78,1.45h0c.47.24,1.03.2,1.47-.1l3.25-2.23c1.38-.95,3.27-.62,4.25.74l3.54,4.93-1.65,10.88,1.65.57,1.48-6.89,4.32.7Z"
                fill="#744c27"
                strokeWidth="0"
            />
            <polygon
                points="1171.03 1778.87 1159.91 1787.82 1161.99 1789.04 1172.13 1783.18 1171.03 1778.87"
                fill="#744c27"
                strokeWidth="0"
            />
            <rect
                x="1150.45"
                y="1772.57"
                width="7.64"
                height="7.8"
                fill="#e5e5e5"
                strokeWidth="0"
            />
            <polygon
                points="1146.3 1770.36 1150.45 1772.57 1150.45 1780.37 1146.3 1778.15 1146.3 1770.36"
                fill="#cbcbcb"
                strokeWidth="0"
            />
            <polyline
                points="1154.46 1776.47 1165.32 1777.5 1167.79 1772.57"
                fill="none"
                stroke="#89623c"
                strokeMiterlimit="10"
                strokeWidth="1.89"
            />
            <path
                d="m1155.47,1757.72s5.07-.08,10.55,3.32l-2.65,2.16-8.26-4.08"
                fill="#5f3817"
                strokeWidth="0"
            />
            <path
                d="m1152.7,1759.76s1.76-3.8,1.8-5c.04-1.2,2.36,2.76.8,5"
                fill="#825c3c"
                strokeWidth="0"
            />
            <polygon
                points="1159.65 1786.76 1158.1 1787.74 1156.15 1786.51 1155.79 1785.04 1157.29 1783.96 1159.42 1784.83 1159.65 1786.76"
                fill="#4d4d4d"
                strokeWidth="0"
            />
            <polygon
                points="1162.92 1788.47 1161.37 1789.44 1159.42 1788.21 1159.06 1786.74 1160.56 1785.66 1162.69 1786.53 1162.92 1788.47"
                fill="#666"
                strokeWidth="0"
            />
            <polygon
                points="1155.39 1777.15 1153.84 1778.12 1151.89 1776.89 1151.53 1775.43 1153.03 1774.35 1155.16 1775.22 1155.39 1777.15"
                fill="#666"
                strokeWidth="0"
            />
            <polygon
                points="1159.77 1783.55 1158.66 1784.24 1157.27 1783.37 1157.02 1782.32 1158.08 1781.55 1159.6 1782.17 1159.77 1783.55"
                fill="#666"
                strokeWidth="0"
            />
            <ellipse
                cx="1150.94"
                cy="1760.86"
                rx=".66"
                ry="1.1"
                fill="#fff"
                strokeWidth="0"
            />
            <line
                x1="1151.14"
                y1="1760.62"
                x2="1154.27"
                y2="1758.93"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth=".33"
            />
            <path
                d="m1147.04,1765.56c-.19,0-.38.02-.56.06-.07.32-.12.65-.16.98l-.1.85c-.07.6.24,1.18.78,1.45.47.24,1.03.2,1.47-.1l1.34-.92c-.24-1.32-1.39-2.32-2.77-2.32Z"
                fill="#edcdcd"
                strokeWidth="0"
            />
        </motion.g>
        <motion.g
            id="YellowBoat"
            initial={{ x: 0, y: 0 }}
            animate={{
                x: [0, 1, 0, 2, -1, 0, 1, -2, 1, 0],
                y: [0, 5, -3, 4, -5, 4, -3, 2, -5, 0],
            }}
            transition={{
                duration: 15,
                repeat: Infinity,
                bounce: 0.25,
            }}
        >
            <path
                d="m952.56,1828.94c-6.15-2.64-6.19-9.24-.06-11.92"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth=".33"
            />
            <path
                d="m950.24,1829.45c-2.69-1.15-4.21-3.07-4.56-5.08"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth=".33"
            />
            <path
                d="m968.77,1809.53l25.88,14.9c5.06,2.91,5.08,10.19.05,13.14l-4.14,2.43c-4.76,2.79-10.65,2.81-15.43.06l-22.63-13.03c-5.5-3.17-5.53-11.09-.06-14.3l5.4-3.16c3.37-1.98,7.54-1.99,10.93-.04Z"
                fill="#f5df61"
                strokeWidth="0"
            />
            <path
                d="m967.55,1827.04h5.46c-2.8,2.69-3.41,6.35,0,11.79l-5.46-3.14c-2.64-4.53-2.45-7.3,0-8.65Z"
                fill="#fbb03b"
                strokeWidth="0"
            />
            <path
                d="m955.92,1820.36h5.46c-1.95,2.47-3.21,5.46,0,11.79l-5.46-3.14c-2.19-5.23-2.16-8.08,0-8.65Z"
                fill="#fbb03b"
                strokeWidth="0"
            />
            <path
                d="m996.58,1839.51l-4.64,2.72c-5.32,3.12-11.92,3.15-17.26.07l-6.55-3.77"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth=".38"
            />
            <path
                d="m994.95,1843.52c-7.15,4.2-16.01,4.23-23.2.09"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth=".38"
            />
            <path
                d="m968.4,1811.44l19.27,11.09c2.34,1.35,2.35,4.72.02,6.09l-6.24,3.66c-2.46,1.44-5.5,1.45-7.98.03l-19.27-11.09c-2.34-1.35-2.35-4.72-.02-6.09l6.24-3.66c2.46-1.44,5.5-1.45,7.98-.03Z"
                fill="#d6b2b2"
                strokeWidth="0"
            />
            <path
                d="m958.59,1816.54s-9.08-6.6-14.84-1.06l2.64,4.02c2.98-4.3,7.33-3.16,11.9-1.76"
                fill="gray"
                strokeWidth="0"
            />
            <polygon
                points="970.22 1820.26 981.4 1829.79 979.32 1831.01 966.68 1823.7 970.22 1820.26"
                fill="#e5e5e5"
                strokeWidth="0"
            />
            <path
                d="m987.25,1803.54s-1.76-3.8-1.8-5c-.04-1.2-2.36,2.76-.8,5"
                fill="#e6e6e6"
                strokeWidth="0"
            />
            <ellipse
                cx="988.76"
                cy="1804.4"
                rx=".66"
                ry="1.1"
                strokeWidth="0"
            />
            <path
                d="m972.87,1821.28l-6.11,6.19-6.37-3.89c-3.72-2.27-3.62-7.71.18-9.85l19.99-11.25c2.17-1.22,4.86-1.05,6.85.44l.31.24c2.32,1.73,3.82,4.34,4.15,7.22l.1.85c.07.6-.24,1.18-.78,1.45h0c-.47.24-1.03.2-1.47-.1l-3.25-2.23c-1.38-.95-3.27-.62-4.25.74l-3.54,4.93,1.65,10.88-1.65.57-1.48-6.89-4.32.7Z"
                fill="#fff"
                strokeWidth="0"
            />
            <polygon
                points="967.16 1822.66 978.28 1831.61 976.2 1832.83 966.06 1826.97 967.16 1822.66"
                fill="#fff"
                strokeWidth="0"
            />
            <rect
                x="980.1"
                y="1816.36"
                width="7.64"
                height="7.8"
                fill="#e5e5e5"
                strokeWidth="0"
            />
            <polygon
                points="991.89 1814.14 987.74 1816.36 987.74 1824.16 991.89 1821.94 991.89 1814.14"
                fill="#cbcbcb"
                strokeWidth="0"
            />
            <line
                x1="987.74"
                y1="1816.36"
                x2="987.74"
                y2="1824.16"
                fill="#cbcbcb"
                strokeWidth="0"
            />
            <polygon
                points="972.32 1822.28 969.56 1816.78 971.25 1815.94 973.43 1820.28 983.64 1819.32 983.82 1821.2 972.32 1822.28"
                fill="#cbcbcb"
                strokeWidth="0"
            />
            <path
                d="m982.72,1801.5s-5.07-.08-10.55,3.32l2.65,2.16,8.26-4.08"
                fill="gray"
                strokeWidth="0"
            />
            <path
                d="m985.49,1803.54s-1.76-3.8-1.8-5-2.36,2.76-.8,5"
                fill="#e6e6e6"
                strokeWidth="0"
            />
            <polygon
                points="978.54 1830.54 980.09 1831.52 982.04 1830.29 982.4 1828.82 980.9 1827.74 978.77 1828.61 978.54 1830.54"
                fill="#4d4d4d"
                strokeWidth="0"
            />
            <polygon
                points="975.27 1832.25 976.82 1833.23 978.77 1832 979.13 1830.53 977.63 1829.45 975.5 1830.32 975.27 1832.25"
                fill="#666"
                strokeWidth="0"
            />
            <polygon
                points="982.8 1820.93 984.35 1821.91 986.3 1820.68 986.66 1819.21 985.16 1818.13 983.03 1819 982.8 1820.93"
                fill="#666"
                strokeWidth="0"
            />
            <polygon
                points="978.43 1827.33 979.53 1828.03 980.92 1827.15 981.18 1826.11 980.11 1825.34 978.59 1825.96 978.43 1827.33"
                fill="#666"
                strokeWidth="0"
            />
            <ellipse
                cx="987.25"
                cy="1804.64"
                rx=".66"
                ry="1.1"
                strokeWidth="0"
            />
            <line
                x1="987.05"
                y1="1804.4"
                x2="983.92"
                y2="1802.71"
                fill="none"
                stroke="#000"
                strokeMiterlimit="10"
                strokeWidth=".33"
            />
            <path
                d="m991.15,1809.35c.19,0,.38.02.56.06.07.32.12.65.16.98l.1.85c.07.6-.24,1.18-.78,1.45-.47.24-1.03.2-1.47-.1l-1.34-.92c.24-1.32,1.39-2.32,2.77-2.32Z"
                fill="#edcdcd"
                strokeWidth="0"
            />
        </motion.g>
    </>
));

Boats.displayName = 'Boats';
export default Boats;
